import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Row, Col, Button } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import {
  setSelectedAccount,
  fetchCustomerDueReport,
  searchCustomers, // ✅ imported thunk
} from "../customerDueSlice";
import SearchListAutoComplete from "../../../../components/SearchListAutoComplete";

const CustomerDueFilters = ({ messageApi }) => {
  const dispatch = useDispatch();
  const { selectedAccount } = useSelector((state) => state.customerDueReport);

  const [searchQuery, setSearchQuery] = useState("");

  // ✅ Wrap thunk dispatcher for SearchListAutoComplete
  const handleSearchCustomers = useCallback(
    (text) => {
     dispatch(searchCustomers({ query: text }));
    },
    [dispatch]
  );

  const handleFilterChange = (field, value) => {
    dispatch(setSelectedAccount(value));
  };

  // Debounced effect (for typing in input)
  useEffect(() => {
    if (searchQuery.trim().length > 2) {
      const timer = setTimeout(() => {
        dispatch(searchCustomers({ query: searchQuery }));
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [searchQuery, dispatch]);

  const handleReport = () => {
    if (!selectedAccount) {
      messageApi.warning("Select Customer");
      return;
    }

    dispatch(
      fetchCustomerDueReport({ customerId: selectedAccount.acc_id })
    ).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        messageApi.success("Report loaded ✅");
      } else {
        messageApi.error("Failed to fetch records ❌");
      }
    });
  };

  return (
    <Card className="mb-4 shadow-md rounded-xl">
      <Row gutter={16} style={{ alignItems: "center" }}>
        <Col xs={24} sm={12} md={8} lg={6} xl={4}>
          <label>Search Customer</label>
          <SearchListAutoComplete
            entityType="customer"
            searchThunk={handleSearchCustomers} // ✅ dispatcher
            resultSelector={(state) => state.customerDueReport.accounts} // redux results
            onSelect={(obj) => handleFilterChange("type", obj)}
            placeholder="Customer"
            showAddNew={false}
          />
        </Col>

        <Col
          xs={24}
          sm={12}
          md={8}
          lg={6}
          xl={4}
          style={{ display: "flex", alignItems: "flex-end", height: 58 }}
        >
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleReport}
            block
            data-testid="btn-get-report"
          >
            Get Report
          </Button>
        </Col>
      </Row>
    </Card>
  );
};

export default CustomerDueFilters;
